import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppContextService, InstitutionType } from './app-context.service';

@Directive({
  selector: '[kgrIfInstitutionType]',
  standalone: true,
})
export class IfInstitutionTypeDirective {
  private isRendered = false;

  constructor(
    private appContextService: AppContextService,
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  @Input()
  set kgrIfInstitutionType(institutionType: InstitutionType) {
    if (this.appContextService.isInstitutionType(institutionType)) {
      if (!this.isRendered) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
      this.isRendered = true;
    } else {
      this.viewContainer.clear();
      this.isRendered = false;
    }
  }
}
